/** yaw wire helpers shared with the server convention (uint16 <-> radians). */
export function uint16ToYaw(v: number): number {
  return (v / 65535) * Math.PI * 2;
}

export function yawToUint16(yaw: number): number {
  const t = ((yaw % (Math.PI * 2)) + Math.PI * 2) % (Math.PI * 2);
  return Math.round((t / (Math.PI * 2)) * 65535) & 0xffff;
}
